import { match2ReplicantUserProperties } from './match2.analytics.scheme';
import {
  Match2TimedRewardType,
  match2TimedRewardTypes,
} from './rewards/match2-rewards.ruleset';
import { isMatch2TimedRewardActive } from './match2.getters';
import { assertNever } from '../utils';
import { State } from '../State';

/**
 * User properties related to timed rewards
 */
type TimedRewardUserProperty = keyof typeof match2ReplicantUserProperties;

/**
 * Get the corresponding user property for a timed reward
 * @param reward
 * @returns
 */
export function getUserPropertyForTimedReward(
  reward: Match2TimedRewardType,
): TimedRewardUserProperty {
  switch (reward) {
    case 'energy':
      return 'infiniteEnergyActive';
    case 'powerups-bomb':
      return 'infiniteBombActive';
    case 'powerups-rocket':
      return 'infiniteRocketActive';
    case 'powerups-cube':
      return 'infiniteCubeActive';
    case 'boosters-dart':
      return 'infiniteDartActive';
    case 'boosters-bullet':
      return 'infiniteBulletActive';
    case 'boosters-drill':
      return 'infiniteDrillActive';
    case 'boosters-roulette':
      return 'infiniteRouletteActive';
    case 'multiplier-frenzy':
      return 'frenzyMultiplierX2Active';
    default:
      assertNever(reward);
  }
}

/**
 * Retrieve all timed reward user properties and their active status
 * @returns
 */
export function getTimedRewardUserProperties(state: State, now: number) {
  const userProps: Partial<Record<TimedRewardUserProperty, boolean>> = {};
  for (const timedRewardType of match2TimedRewardTypes) {
    const isActive = isMatch2TimedRewardActive(state, timedRewardType, now);
    const userProp = getUserPropertyForTimedReward(timedRewardType);
    userProps[userProp] = isActive;
  }
  return userProps;
}
